import { store } from '@/store';
import constants from './constants';

const empty = {
  name: null,
  resourceData: null,
  subdomain: null,
};

const getInternalLinkProps = (url) => {
  const resource = url.split('://')[1];
  if (!resource) {
    return empty;
  }
  const [, subdomain, resourceData] = resource ? resource.split('/') : url.split('/');
  if (!subdomain || !resourceData) return empty;
  const [resourceType, resourceId] = resourceData.split('-') || '';
  let name = '';

  if (['card', 'board', 'page', 'project'].includes(resourceType)) {
    const nameArray = resourceData.split('-');
    nameArray.splice(0, 2);
    name = nameArray.join(' ');
  }
  if ([constants.projectSlug].includes(resourceType)) {
    const project = store.getters.getTeamProjectById(resourceId);
    if (!project) return '';
    name = project.title;
  }

  let nameArr = name.split('?');
  if (nameArr.length === 1) {
    nameArr = name.split('#');
  }
  name = nameArr.length > 1 ? nameArr[0] : name;
  return {
    name,
    resourceData,
    subdomain,
  };
};

const isInternalLink = (url) => {
  const isInternalLink = constants.hRx.test(url);
  if (!isInternalLink) return false;

  const fullUrl = url.startsWith('https://') ? url : `https://${url}`;
  const teamSlug = store.getters.getTeamSlug;
  const { resourceData, subdomain } = getInternalLinkProps(fullUrl);
  if (!resourceData || !subdomain) return false;
  const isSettingsPage = resourceData === 'settings';
  const isSameTeamSlug = teamSlug === subdomain;

  return isInternalLink && isSameTeamSlug && !isSettingsPage;
};

const isNotInternalLink = (url) => {
  return !isInternalLink(url);
};

export { isInternalLink, isNotInternalLink, getInternalLinkProps };
